module.exports = __webpack_public_path__ + "6a9a22aa09d95e9cc655d63184743d5a.png";